import { atom } from "recoil";

export type key = string | undefined;


export const keyStore = atom<key>({
  key: "keyStoreKey",
  default: undefined
})